import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { PieChart } from '@mui/x-charts/PieChart'
import StatsSummary from '../../../StatsSummary'
import { formatDate } from '../../../../utils/formatDate'

const UiTestingAccordion = ({ pageData }) => {
  const passedPercent = (pageData.page.passed_ui_test_count / (pageData.page.passed_ui_test_count + pageData.page.failed_ui_test_count)) * 100
  const uiTestingData = [
    { id: 0, value: passedPercent.toFixed(2), label: 'Passed', color: '#8BC34A' },
    { id: 1, value: 100 - passedPercent.toFixed(2), label: 'Failed', color: '#F44336' },
  ]

  return <Box className='uiTestingAccordionContainer'>
    <Accordion className='uiTestingAccordion' defaultExpanded>
      <AccordionSummary className='uiTestingAccordionSummary' expandIcon={<ExpandMoreIcon/>}>
        <Typography className='uiTestingAccordionSummaryTitle'>UI Testing</Typography>
      </AccordionSummary>
      <AccordionDetails className='uiTestingAccordionDetails'>
        <Box className="uiTestingAccordionStatsSection">
          <StatsSummary title="Last UI Scan Date" value={formatDate(pageData?.page.last_scanned_at)} color="primary" />
          <StatsSummary title="Total Scrolls" value={pageData?.blocks.length > 1 ? pageData?.blocks.length - 1 : 1} color="primary" />
          <StatsSummary title="Total Issues" value={pageData?.page.issue_count} color="primary" />
          <StatsSummary title="Issue Rate" value={`${100 - passedPercent.toFixed(2)}%`} color={passedPercent < 100 ? "#d32f2f" : "#198754"} />
        </Box>
        <PieChart
          series={[
            {
              data: uiTestingData,
              innerRadius: 50,
              outerRadius: 100,
              startAngle: -90,
              endAngle: 90,
              cx: 110,
              cy: 100,
            },
          ]}
          width={376}
          height={124}
          sx={{ pt: 1, ml: 4 }}
        />
      </AccordionDetails>
    </Accordion>
  </Box>
}

export default UiTestingAccordion